import React, { HTMLAttributes, useMemo } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { SxProps } from '@mui/system'
import Box from '@mui/material/Box'

type ControlBarProps = HTMLAttributes<HTMLDivElement> & {
  anchorOrigin?: {
    horizontal: 'right' | 'center' | 'left',
    vertical: 'top' | 'bottom'
  },
  position?: 'absolute' | 'fixed' | 'relative'
}

export default function ControlBar(props: ControlBarProps) {
  const {
    anchorOrigin: { horizontal, vertical } = { horizontal: 'left', vertical: 'top' },
    children,
    position = 'fixed',
    ...rest
  } = props
  useLingui()

  const sxProp: SxProps = useMemo(() => {
    const center = {
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)'
    }

    return {
      zIndex: '1',
      position,
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center',
      ...(vertical === 'top' ? { top: 24 } : { bottom: 24 }),
      ...(horizontal === 'center' && center),
      ...(horizontal === 'left' && { left: 24, right: 'auto' }),
      ...(horizontal === 'right' && { right: 24, left: 'auto' })
    }
  }, [horizontal, vertical, position])

  return (
    <Box {...rest} component="div" role="toolbar" aria-label={t`Consultation controls`} sx={sxProp}>
      {children}
    </Box>
  )
}